const Footer = () => {
    return (
        <footer>
            <p className ="footer-text" 
                style={{
                    margin: '0',
                    fontSize: '18px',
                    textAlign: 'center',
                    color: 'white',
                    padding: '10px',
                    textDecoration: 'none'
                }}>
                © 2024 Ligaincom. All rights reserved.</p><small className="float-end me-1">Diseño y desarrollo por Alejandro Travé <a href="mailto:atravep@gmail.com">atravep@gmail.com</a></small>
        </footer>
    );
};

export default Footer;